import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';
import { useNotificationContext } from '@/contexts/NotificationCtx';
import { useTranslation } from 'react-i18next';

import '@/App.css'

type LoginProps = {
  loginApi: string;
  msg: string | null;
};

function isProdEnv(env: Record<string, string>) : boolean {
  //should be only defined in stable
  return env.VITE_PRODUCTION_ENVIRONMENT !== undefined;
}

export function Login({ loginApi, msg: errorMessage }: LoginProps) {
  const { t } = useTranslation();
  const notifyCtx = useNotificationContext();
  const prodEnv: boolean = isProdEnv(import.meta.env);

  const msIcon = (
    <Icon>
      <img alt="edit" src="/ms.png" width={25} height={25} />
    </Icon>
  );

  function showNotificationMessage(msg: string) {
    notifyCtx?.showNotification('error', msg, undefined, 60);
  }

  if (errorMessage) {
    showNotificationMessage(errorMessage);
  }

  return (
    <>
      <div className="login-parent">
        <div className="login-container">
          <div>
            <img src="/svg/logo-eon-red.svg" alt="Eon logo" className="logo-img"></img>
            {!prodEnv && 
              <>
                <div className="testing">{t('general.testing')}</div>
                <div className="testing-info">{t('general.testinginfo')} <a href="https://uton.itrack.hu/"> https://uton.itrack.hu </a></div>
              </>
             }
          </div>
          <h2>{t('login.welcome')}</h2>
          <Button
            variant="outlined"
            sx={{
              paddingLeft: 10,
              paddingRight: 10,
              position: 'relative',

              '& .MuiButton-startIcon': {
                position: 'absolute',
                left: 16,
                paddingBottom: 0.5,
              },
            }}
            startIcon={msIcon}
            href={loginApi}
            color="error"
          >
            {t('login.microsoft')}
          </Button>
        </div>
      </div>
    </>
  );
}
